export const PATROL_LAB_QUESTIONS = ['short', 'sitting', 'longest'] as const;
export type PatrolLabQuestionVariant = (typeof PATROL_LAB_QUESTIONS)[number];

export const PATROL_LAB_QUESTION_SHORT = 'Explain why the lock must be canonical.';

export const PATROL_LAB_SITTING_TITLE = 'Distributed Intake Reconciliation';
export const PATROL_LAB_SITTING_LEAD = 'Four clinics share intake summaries while keeping bedside notes locally. After an outage, two sites show conflicting allergy flags for one visit. Design a model that prevents silent divergence without making every clinician wait on a central round trip.';

export const PATROL_LAB_SITTING_BULLETS = [
  'Name the source of truth and write authority for each fact.',
  'Explain what staff see during conflict and how rollback works.',
] as const;

/** Concise commissioning copy plus two `- ` bullet lines — not a real exam question. */
export const PATROL_LAB_QUESTION_SITTING = [
  `${PATROL_LAB_SITTING_TITLE}: ${PATROL_LAB_SITTING_LEAD}`,
  ...PATROL_LAB_SITTING_BULLETS.map((bullet) => `- ${bullet}`),
].join('\n');

/** Made-up commissioning copy (~1,000 characters) — not a real exam question. */
export const PATROL_LAB_QUESTION_LONGEST = 'Transit Dispatch Revision: A municipal agency is replacing paper run sheets with a live dispatch board for controllers, drivers, and maintenance crews. Controllers re-route buses when closures appear; drivers acknowledge hops from tablets that may lose LTE; maintenance logs block updates that must appear without duplicating vehicle identifiers. During a pilot, two controllers edited the same run sheet after a tunnel closure and the board showed one bus on overlapping routes until a manual reset. Explain how you would model run sheet revisions so concurrent edits cannot fork state, how offline tablets reconcile on reconnect, and what operators see while a deferred merge applies instead of live GPS. Assume the agency cannot stop service for a big-bang cutover and must keep read-only history for auditors. Discuss consistency, idempotency keys, conflict surfacing for controllers, and the minimum telemetry required before trusting an automatic merge at rush hour.';

export function resolvePatrolLabQuestionText(
  variant: PatrolLabQuestionVariant | undefined,
): string {
  switch (variant) {
    case 'sitting':
      return PATROL_LAB_QUESTION_SITTING;
    case 'longest':
      return PATROL_LAB_QUESTION_LONGEST;
    case 'short':
    default:
      return PATROL_LAB_QUESTION_SHORT;
  }
}
